<script setup>
const props = defineProps(["class"]);
</script>

<template>
    <svg
        viewBox="0 0 21.43 21.45"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="class"
    >
        <path
            d="M4.44298 -0.00683594H16.9852C19.4463 -0.00683594 21.4277 1.9769 21.4277 4.441V16.9982C21.4277 19.4623 19.4463 21.446 16.9852 21.446H4.44298C1.98184 21.446 0.000488281 19.4623 0.000488281 16.9982V4.441C0.000488281 1.9769 1.98184 -0.00683594 4.44298 -0.00683594Z"
            fill="#FDDB32"
        />
        <path
            d="M5.99204 3.82764C5.79238 3.82764 5.66688 3.87358 5.56115 3.97944L3.42002 6.12315C3.38026 6.16295 3.35792 6.21698 3.35791 6.27327C3.3579 6.39047 3.45282 6.48548 3.56988 6.48549H12.8518L7.1455 12.1985C7.03305 12.3111 6.96763 12.3766 6.96764 12.5976L6.96763 14.1007C6.96763 14.1918 7.00899 14.2707 7.06833 14.3301C7.12767 14.3895 7.20638 14.4308 7.2973 14.4308H8.79875C9.01944 14.4308 9.08476 14.3654 9.19721 14.2528L14.9035 8.53967V17.8327C14.9035 17.9499 14.9984 18.045 15.1155 18.045C15.1717 18.0449 15.2256 18.0226 15.2654 17.9828L17.4065 15.8391C17.5123 15.7332 17.5582 15.6076 17.5581 15.4077L17.5581 5.26016C17.5581 5.07203 17.5211 4.88575 17.4492 4.71194C17.3773 4.53814 17.2719 4.38022 17.139 4.2472C17.0062 4.11418 16.8484 4.00866 16.6748 3.93667C16.5012 3.86468 16.3152 3.82763 16.1273 3.82764L5.99204 3.82764Z"
            fill="#191E3B"
        />
        <path
            d="M4.17279 14.8472H6.23234C6.40462 14.8472 6.54331 14.986 6.54331 15.1585V17.2334C6.54331 17.4059 6.40462 17.5448 6.23234 17.5448H4.17279C4.00051 17.5448 3.86182 17.4059 3.86182 17.2334V15.1585C3.86182 14.986 4.00051 14.8472 4.17279 14.8472Z"
            fill="#191E3B"
        />
    </svg>
</template>
